import i18n from '@i18next/i18n';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { ElementBaseAccessibilityContent } from './base';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ShapeAccessibilityContent } from './shape';
import { IAccessibilityManagerContentHandler } from '@src/slide/application/service/accessibility-manager/core/accessibility-manager.interface';

export class TableAccessibilityContent extends ElementBaseAccessibilityContent {
    private tableModel: ITableModel;
    public constructor(model: ITableModel, a11yManager: IAccessibilityManagerContentHandler) {
        super(model, a11yManager);
        this.tableModel = model;
    }

    public getAccessibilityContent(isSelected = false, content = ''): string {
        const rowLength = this.tableModel.tableItems[0].length;
        const columuLenth = this.tableModel.tableItems.length;
        let tempContent = i18n.t('表格：{0}行，{1}列。', { 0: rowLength, 1: columuLenth });
        this.tableModel.tableItems.forEach((row, rowIndex) => {
            row.forEach((column, columnIndex) => {
                const columnContent = this.getShapeAccessibilityContent(column, isSelected, content);
                if (columnIndex === 0) {
                    tempContent += i18n.t('第{0}行，第1列，{1}', { 0: rowIndex + 1, 1: columnContent });
                } else {
                    tempContent += i18n.t('第{0}列，{1}', { 0: columnIndex + 1, 1: columnContent });
                }
            });
        });
        return tempContent;
    }

    private getShapeAccessibilityContent(model: IShapeModel, isSelected = false, content = ''): string {
        return new ShapeAccessibilityContent(model, this.a11yManager).getAccessibilityContent(isSelected, content);
    }
}
